module.exports = __webpack_public_path__ + "img/dashed.5492bca4.svg";